import { GridSearchEntityInstance } from '@models/module/grid';

export const GANTT_DATE_FIELDS_TYPE_MISMATCH_ERROR = 'errors.dateFieldsDifferentTypes';

export type GanttPointData = Highcharts.GanttPointOptionsObject & {
  id?: string;
  parent?: string;
  completed?: number;
  dependency?: string[];
  className?: string;
  milestone?: boolean;
  custom?: GridSearchEntityInstance;
};

export type GanttFormatterPoint = Highcharts.Point & {
  start: number;
  end: number;
  custom?: GridSearchEntityInstance;
};